import template from './admin-fax-search.html';
import {adminStates} from '../../admin-routes';

AdminFaxSearch.DIRECTIVE_NAME = 'ktAdminFaxSearch';
export default function AdminFaxSearch() {
    return {
        restrict: 'A',
        controller: AdminFaxSearchController,
        controllerAs: 'adminFaxSearchCtrl',
        template,
        bindToController: true,
        link,
    };

    function link($scope, $elem, $attrs, adminFaxSearchCtrl) {
        adminFaxSearchCtrl.$onInit();
    }
}

export function AdminFaxSearchController(
    $scope,
    $state,
    adminFaxSearchService,
    userService
) {
    'ngInject';

    const vm = this;
    const defaultSearchParams = {
        referenceNo: null,
        sentDates: {
            from: null,
            to: null,
        },
        hotelName: null,
        arrivalDate: null,
        tripId: null,
        pnr: null,
        documentType: [],
        faxStatus: [],
    };
    const {dateFormat} = userService.getRegionalSettings();

    const showAllOption = {
        id: 'showAll',
        label: 'Show all',
    };

    Object.assign(vm, {
        $onInit,
        searchFaxes,
        search: defaultSearchParams,
        //we should set calendar options on ctrl creation
        //if we do that in $onInit method, the calendar will not init properly
        fromDateOptions: adminFaxSearchService.getFromDateOptions(),
        toDateOptions: adminFaxSearchService.getToDateOptions(),
        arrivalDateOptions: adminFaxSearchService.getArrivalDateOptions(),
    });

    function $onInit() {
        vm.faxDocumentTypes = getFaxDocumentTypes();
        vm.faxStatuses = getFaxStatuses();
        watch();
    }

    function watch() {
        $scope.$watch(() => vm.search.sentDates, ({from, to}) => {
            if (from && to) {
                const fromDate = moment(from, dateFormat);
                const toDate = moment(to, dateFormat);

                if (fromDate.isAfter(toDate)) {
                    vm.search.sentDates.to = null;
                }
            }
        }, true);

        $scope.$watch(() => vm.search.sentDates.from, (newVal) => {
            if (newVal) {
                vm.toDateOptions.start = moment(newVal, dateFormat);
                vm.toDateOptions.after = moment(newVal, dateFormat).add({days: -1});
            }
        });
    }

    function searchFaxes() {
        const params = adminFaxSearchService.processParams(vm.search);
        $state.go(
            adminStates.FAX_LIST_RESULTS,
            params,
            {reload: adminStates.FAX_LIST_RESULTS}
        );
    }

    function getFaxDocumentTypes() {
        return [showAllOption, ...adminFaxSearchService.getDefaultFaxDocumentTypes()];
    }

    function getFaxStatuses() {
        return [showAllOption, ...adminFaxSearchService.getDefaultFaxStatuses()];
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-search/admin-fax-search-component.js